<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        {{ 'Add_User' | translate}}
    </h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            {{'Users' | translate}}
        </li>
        <li class="breadcrumb-item position-relative">
            {{'Add_User' | translate}}
        </li>
    </ol>
</div>

<!-- Add User -->
<div>
    <mat-card class="daxa-card add-user-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mb-0">
                    {{ 'Add_User' | translate}}
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="alert alert-bg-success d-flex justify-content-between align-items-center" role="alert"
                *ngIf="addUserSuccess">
                {{ 'User_Added_Successfully' | translate }}
                <button type="button" class="close bg-transparent text-white p-0 border-none" data-dismiss="alert"
                    aria-label="Close" (click)="closeAlertManully()">
                    <i class="ri-close-line"></i>
                </button>
            </div>

            <div class="alert alert-bg-danger d-flex justify-content-between align-items-center" role="alert"
                *ngIf="addUserErrorMessage">
                {{ addUserErrorMessage }}
                <button type="button" class="close bg-transparent text-white p-0 border-none" data-dismiss="alert"
                    aria-label="Close" (click)="closeAlertManully()">
                    <i class="ri-close-line"></i>
                </button>
            </div>

            <form [formGroup]="addUserForm">
                <div class="add-user-form">
                    <mat-form-field>
                        <mat-label>{{ 'First_name' | translate }}</mat-label>
                        <input matInput formControlName="firstName" />
                        <mat-error *ngIf="addUserForm.get('firstName')?.invalid">
                            {{ 'First Name is required' | translate }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>{{ 'Last_name' | translate }}</mat-label>
                        <input matInput formControlName="lastName" />
                        <mat-error *ngIf="addUserForm.get('lastName')?.invalid">
                            {{'Last Name is required' | translate }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>{{ 'Email' | translate }}</mat-label>
                        <input matInput formControlName="email" />
                        <mat-error *ngIf="addUserForm.get('email')?.invalid">
                            {{ 'Please enter a valid email address' | translate }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>{{ 'Phone_number' | translate }}</mat-label>
                        <input matInput formControlName="phone" />
                        <mat-error *ngIf="addUserForm.get('phone')?.invalid">
                            {{ 'Phone is required' | translate }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>{{ 'Username' | translate }}</mat-label>
                        <input matInput formControlName="username" />

                        <mat-error *ngIf="addUserForm.get('username')?.hasError('required')">
                            {{ 'Username is required' | translate }}
                        </mat-error>
                        <mat-error *ngIf="addUserForm.get('username')?.hasError('pattern')">
                            {{ 'Username can not contain space' | translate }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-label>{{'User_group' | translate }}</mat-label>
                        <mat-select formControlName="userGroupId">
                            <mat-option *ngFor="let g of userGroups" [value]="g.id">
                                {{ g.title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>


                    <mat-form-field>
                        <mat-label>{{ 'Password' | translate }}</mat-label>
                        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
                            [errorStateMatcher]="matcher" />
                        <button mat-icon-button type="button" matSuffix (click)="hidePassword = !hidePassword"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                            <span class="material-symbols-outlined">
                                {{ hidePassword ? "visibility_off" : "visibility" }}
                            </span>
                        </button>
                        <mat-error *ngIf="addUserForm.get('password')?.hasError('passwordStrength')">
                           {{'Password must have: ' | translate}}
                            <span *ngIf="!addUserForm.get('password')?.errors?.['passwordStrength']?.hasMin8Chars">
                                {{"At least 8 characters" | translate}},
                            </span>
                            <span *ngIf="!addUserForm.get('password')?.errors?.['passwordStrength']?.hasUpperChar">
                                {{"An uppercase letter" | translate}},
                            </span>
                            <span *ngIf="!addUserForm.get('password')?.errors?.['passwordStrength']?.hasLowerChar">
                                {{"A lowercase letter" | translate}},
                            </span>
                            <span *ngIf="!addUserForm.get('password')?.errors?.['passwordStrength']?.hasNumber">
                                {{"A number" | translate}}.
                            </span>
                        </mat-error>

                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{ 'Confirm_password' | translate }}</mat-label>
                        <input matInput [type]="hidePasswordConfirm ? 'password' : 'text'"
                            formControlName="confirmPassword" />
                        <button mat-icon-button type="button" matSuffix
                            (click)="hidePasswordConfirm = !hidePasswordConfirm" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hidePasswordConfirm">
                            <span class="material-symbols-outlined">
                                {{ hidePasswordConfirm ? "visibility_off" : "visibility" }}
                            </span>
                        </button>
                        <mat-error *ngIf="addUserForm.get('confirmPassword')?.hasError('required')">
                            {{'Password confirmation is required' | translate}}
                        </mat-error>
                        <mat-error *ngIf="addUserForm.get('confirmPassword')?.invalid">
                            {{'Passwords do not match' | translate}}
                        </mat-error>

                    </mat-form-field>
                </div>
            </form>

            <div class="btn-box">
                <button mat-raised-button color="primary" class="daxa" type="submit"
                    [disabled]="addUserForm.invalid || addUserForm.pending || isLoading" (click)="addUser()">

                    <mat-progress-spinner *ngIf="isLoading" diameter="18" mode="indeterminate" strokeWidth="3"
                        class="mr-2">
                    </mat-progress-spinner>

                    <span>{{ isLoading ? 'Submitting…' : ('Add_User' | translate) }}</span>
                </button>
                <button mat-raised-button type="button" color="warn" routerLink="/users/users-list">
                    {{ 'Cancel' | translate }}
                </button>
            </div>
        </mat-card-content>
    </mat-card>
</div>